import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from '../services/authentication.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.html'
  })
  export class ContactComponent implements OnInit {

    form1: FormGroup;
    submitting = false;

    constructor( private fb: FormBuilder , private authService : AuthenticationService){
      this.ngOnInit();
    }

    ngOnInit(): void {
      this.form1 = this.fb.group({
        name: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required]),
        subject: new FormControl('', [Validators.required]),
        cellnumber: new FormControl('', [Validators.required]),
        message: new FormControl('', [Validators.required])
      })
    }

    onSubmit(){
      this.submitting = true;
      this.authService.contactUs(this.form1.value);
    }
  }